export default "__VITE_ASSET__Dt3$3Ct9__"